// @ts-nocheck
import { capitalize } from 'lodash';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useReportingMap } from 'sonata-platform-components';

import { formatValue, getDefaultMessageSelectorKpis } from '@/helpers/reporting.helpers';
import { getBaseCurrency } from '@/store/selectors/baseCurrency.selectors';
import { getCurrency } from '@/store/selectors/reportingAdvancedFilter.selectors';
import { MapPopupContentStyle } from './mapPopupContent.style';

import type { BaseItemData } from 'sonata-platform-components/lib/types/types/reportingMap.types';

type Props = {
  className?: string;
  itemId: string;
  itemLabel: string;
  mapId: string;
  metricLabel: string;
};

export function MapPopupContent({ className = '', itemId, itemLabel, mapId, metricLabel }: Props) {
  const { formatMessage } = useIntl();
  const { getMapData } = useReportingMap();
  const data: BaseItemData[] = getMapData({ id: mapId });
  // @ts-ignore
  const currentCurrency = useSelector(store => getCurrency(store, 'general'));
  // @ts-ignore
  const currencyInfo = useSelector(store => getBaseCurrency(store, currentCurrency));
  const selectedItem = data.find(({ _id }) => _id === itemId);
  const fixed: number = selectedItem && parseFloat(selectedItem.metric) % 1 > 0 ? 2 : 0;
  const normalizedMetric = formatValue(selectedItem?.metric, metricLabel, currencyInfo, fixed, true);

  return (
    <MapPopupContentStyle className={`cartographyMapPopupContent ${className}`}>
      <div className="cartographyMapPopupContent__itemContainer">
        <span className="cartographyMapPopupContent__itemLabel">{itemLabel}</span>
        <span className="cartographyMapPopupContent__itemValue">{selectedItem?.name || itemId}</span>
      </div>
      <div className="cartographyMapPopupContent__metricContainer">
        <span className="cartographyMapPopupContent__itemLabel">
          {formatMessage({
            defaultMessage: getDefaultMessageSelectorKpis(metricLabel) || capitalize(metricLabel),
            id: `reporting.metrics.${metricLabel}`
          })}
        </span>
        <span className="cartographyMapPopupContent__itemValue">{normalizedMetric}</span>
      </div>
    </MapPopupContentStyle>
  );
}
